import { Controller } from "@hotwired/stimulus"

// Generic controller to load content via Turbo Stream when an element changes
export default class extends Controller {
  static values = { url: String }

  load(event) {
    const url = event.target.dataset.turboLoaderUrlValue
    
    if (!url) {
      console.error("No URL provided for turbo-loader")
      return
    }

    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html))
      .catch((error) => console.error("Turbo load error:", error))
  }
}


